import type { ChatPreviewType } from '@odo/shared-ui';

// Chosen from the STORED mime type, never sniffed from the signed URL.
export function previewTypeFor(mimeType: string | null | undefined): ChatPreviewType | null {
    if (!mimeType) return null;
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType === 'application/pdf') return 'pdf';
    return null;
}
